import { ContactPrivacySettingsAPIElementContentModel } from '@/services/platform/api/model';
import { ModuleProperties } from '@/lib/core';
import { ContactPrivacySettingsPage } from '@/components/shared/profile/settings/contact-privacy';

export const ContactPrivacySettingsApi = (props: ModuleProperties) => {
  const content = props.content as ContactPrivacySettingsAPIElementContentModel | undefined;
  if (!content) return null;
  return (
    <div className="fixed inset-0 z-50 bg-white">
      <ContactPrivacySettingsPage content={content} />
    </div>
  );
};
